"use strict";

exports.boolConj = function (b1) {
  return function (b2) {
    return b1 && b2;
  };
};

exports.boolDisj = function (b1) {
  return function (b2) {
    return b1 || b2;
  };
};

exports.boolNot = function (b) {
  return !b;
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/HeytingAlgebra.js
// module id = 84
// module chunks = 0